/**
 * @module actions/users
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Get releases
 * @return {Promise} Axios promise
 */
export function getReleases () {
  let url = API_URL + '/Performance/Releases/Get'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Create or update release
 * @return {Promise} Axios promise
 */
export function postRelease (data) {
  let url = API_URL + '/Performance/Releases/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get response time statistics
 * @return {Promise} Axios promise
 */
export function getResponseTimeStatistics (type) {
  let url = API_URL + `/Performance/ResponseTime/Get/${type}`
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/performance.js